<template>
    <el-input v-bind="$attrs" :type="type" :value="innerValue" @input="handleInput" @blur="handleBlur"
        v-on="$listeners">
        <!-- 插槽透传 -->
        <template v-for="(slot, name) in $slots" v-slot:[name]="slotProps">
            <slot :name="name" v-bind="slotProps"></slot>
        </template>
    </el-input>
</template>

<script>
export default {
    name: 'ElInputTrim',
    inheritAttrs: false, // 避免重复绑定属性
    props: {
        value: [String, Number],
        type: {
            type: String,
            default: 'text'
        },
        valueType: {
            type: String,
        }
    },
    data() {
        return {
            innerValue: this.value
        };
    },
    watch: {
        value(val) {
            if (this.valueType === 'int') {
                this.innerValue = +(val + '').replace(/\D/g, '');
            } else {
                this.innerValue = val;
            }
        }
    },
    methods: {
        handleInput(val) {
            let filtered = val; 
            if (this.valueType === 'int'){
                filtered = +(val + '').replace(/\D/g, ''); // 只保留数字
            }
            this.innerValue = filtered;
            this.$emit('input', filtered); // 支持 v-model
        },
        handleBlur(event) {
            if (typeof this.innerValue === 'string') {
                const trimmed = this.innerValue.trim();
                if (trimmed !== this.innerValue) {
                    this.innerValue = trimmed;
                    this.$emit('input', trimmed);
                }
            }
            this.$emit('blur', event); // 原始 blur 事件也透传
        }
    }
};
</script>
